import { Monitor, Moon, Sun } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useTheme } from "@/hooks/useTheme";
import { cn } from "@/lib/utils";

const OPTIONS = [
  { value: "system", label: "Use the device theme", icon: Monitor },
  { value: "light", label: "Light theme", icon: Sun },
  { value: "dark", label: "Dark theme", icon: Moon },
];

/** System, light or dark: a small three-way switch (Cal.com's pattern). */
export const ThemeToggle = ({ className }) => {
  const { theme, setTheme } = useTheme();
  return (
    <ToggleGroup
      type="single"
      size="sm"
      value={theme}
      onValueChange={value => value && setTheme(value)}
      aria-label="Theme"
      data-testid="theme_toggle"
      className={cn("rounded-md border bg-card p-0.5", className)}
    >
      {OPTIONS.map(({ value, label, icon: Icon }) => (
        <ToggleGroupItem
          key={value}
          value={value}
          aria-label={label}
          title={label}
          data-testid={`theme_${value}`}
          className="h-7 min-w-7 rounded-sm first:rounded-sm last:rounded-sm data-[state=on]:bg-muted data-[state=on]:text-foreground"
        >
          <Icon className="size-3.5" />
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
};
